<template>
    <main>
        <h1 >{{msg}}</h1>
        <p>Not Found</p>
    </main>
</template>

<script>
    export default {
        name: 'not-found-component',
                data () {
            return {
                msg: '404'
            }
        }
    }
</script>


<style scoped>

</style>
